import axios from 'axios';

const model = 'Curso'
const API_URL = process.env.VUE_APP_API_URL;

export default {
  get() {
    return axios.get(`${API_URL}/${model}/v1/list`);
  },

  getCasas() {
  const casas = [
    { Id: 'Lancaster', Glosa: 'Lancaster' },
    { Id: 'London', Glosa: 'London' },
    { Id: 'Bristol', Glosa: 'Bristol' },
    { Id: 'Manchester', Glosa: 'Manchester' },
    { Id: 'York', Glosa: 'York' },
    { Id: 'Oxford', Glosa: 'Oxford' },
    { Id: 'A', Glosa: 'A' },
    { Id: 'B', Glosa: 'B' },
    { Id: 'C', Glosa: 'C' },
    { Id: 'D', Glosa: 'D' },
    { Id: 'F', Glosa: 'F' },
    { Id: 'G', Glosa: 'G' },
    { Id: 'H', Glosa: 'H' },
    { Id: 'I', Glosa: 'I' },
    { Id: 'J', Glosa: 'J' },
    { Id: 'K', Glosa: 'K' },
    { Id: 'L', Glosa: 'L' },
    { Id: 'M', Glosa: 'M' },
    { Id: 'N', Glosa: 'N' }
    
  ];
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ data: casas });
      }, 1000);
    });
  },


}